<script>
    import Dialog from "../Dialog.svelte";
    import NewProjectButton from "../NewProjectButton.svelte";
    import Emoji from "../Emoji.svelte";
    import LoadingSpinner from "../LoadingSpinner.svelte";

    import Paper, {Title, Subtitle, Content} from '@smui/paper';
    import Button, {Label} from '@smui/button';
    import FaIcon from 'fa-svelte'
    import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';

    // TODO: wrap into some kind of standardized eventbus
    const dispatch = createEventDispatcher();

    export let show;
    export let showActions;
    export let isNewUser = false;

</script>

<Dialog {show} width={500} class="dialog-welcome">
    <h1>Welcome to Evalueaid! <Emoji name="wave" scale={3}/></h1>
    <p>
        We're happy you've decided to take the future of your company in your own hands.
        {#if showActions}
            Create a new project to get started.
        {:else}
            Loading...
        {/if}
    </p>
    {#if showActions}
        <div class="project-types" transition:fade>
            <!-- TODO: extract into component -->
            <Paper class="project-type active" elevated={1} >
                <Emoji name="pie" scale={3}/>
                <h2>ParticipAid</h2>
                <p class="description">
                    Invite team members, collaborators and contractors to work on your business.
                    Track the value of their contributions over time.
                    Reward all participants with shares.
                </p>

                <Button style="padding: 10px 0;" on:click={() => dispatch("new", "participaid")} variant="raised">
                    <Label>
                        <FaIcon icon={faPlus}>
                        </FaIcon>
                        New Partipie
                    </Label>
                </Button>
            </Paper>

            <!-- TODO: extract into component -->
            <Paper class="project-type" >
                <Emoji name="gem" scale={3} grayscale={true}/>
                <h2>ValueAid</h2>
                <p class="description">
                    Value your business according to your own metrics using industry-standard methods.
                    Embed or share your valuation when fundraising.
                </p>
                <button disabled>Coming soon</button>
            </Paper>

            <!-- TODO: extract into component -->
<!--            <Paper class="project-type" >-->
<!--                <Emoji name="performing_arts" scale={3} grayscale={true}/>-->
<!--                <h2>TeamAid</h2>-->
<!--                <p class="description">-->
<!--                    Valuate your team member's qualities. Identify gaps and weaknesses.-->
<!--                </p>-->
<!--                <button disabled>Coming soon</button>-->
<!--            </Paper>-->
        </div>
    {:else}
        <LoadingSpinner scale={2}/>
    {/if}
</Dialog>

{#if isNewUser}
    <a href="/logout" class="logout-link">Logout</a>
{/if}

<style>
    * {
        text-align: center;
    }

    .logout-link {
        text-align: center;
        color: white;
        //background: #fff;
        margin: auto;
        padding: 10px;
        border-radius: 50px;
        text-transform: lowercase;
        font-size: 13px;
        font-weight: 700;
        display: inline-block;
        margin-top: 10px;
    }

    .project-types {
        display: flex;
        flex-direction: row;
    }

    :global(.dialog-welcome .project-type) {
        flex: 1;
        border: 4px solid transparent;
        padding: 25px;
        display: flex;
        flex-direction: column;
    }

    /*.project-type:hover {
        border: 4px solid #ddd;
    }*/

    /*.project-type.active {
        border: 4px solid #888;
    }*/

    :global(.dialog-welcome .project-type h2) {
        margin: 0;
    }

    :global(.dialog-welcome .project-type .description) {
        font-style: italic;
        font-size: 12px;
        flex: 1;
        margin: 15px 0;
    }
</style>